import React, { useCallback, useState } from "react";
import { CanEdit } from "@/shared/readOnlyManager";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";

import SelectProgram from "../components/SelectProgram";
import Teams from "./components/Teams";
import ModalWrapper from "./components/ModalWrapper";
import TemplateButton from "@/shared/components/TemplateButton";

const Team = ({ auth, program, organization }) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const [modalName, setModalName] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const openModal = useCallback((name) => {
    setModalName(name);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalName(null);
    setOpen(false);
  }, []);

  const handleTeamSaved = useCallback(() => {
    closeModal();
    setRefreshToken((previous) => previous + 1);
  }, [closeModal]);

  if (!auth || !program || !organization) {
    return (
      <div className="manager-home manager-team-page">
        <Container className="manager-home__shell manager-home__content">
          <div className="manager-card manager-card--loading">
            {t("loading")}
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="manager-home manager-team-page">
      <Container className="manager-home__shell manager-home__content">
        <div className="manager-team">
          <section className="manager-card manager-team__hero">
            <div className="manager-team__hero-copy">
              <span className="manager-card__eyebrow">Team</span>
              <h1 className="manager-team__title">Program Team</h1>
              <p className="manager-team__description">
                Manage the teammates and contact details shown for the selected
                program.
              </p>
            </div>
          </section>

          <section className="manager-card manager-team__panel">
            <div className="manager-team__panel-head">
              <div>
                <span className="manager-card__eyebrow">Directory</span>
                <h2 className="manager-card__title">Team Members</h2>
              </div>

              <div className="manager-team__panel-actions">
                <div className="manager-team__control">
                  <span className="manager-team__control-label">Program</span>
                  <div className="manager-team__control-body">
                    <SelectProgram
                      showRefresh={false}
                      label={null}
                      variant="manager-report"
                    />
                  </div>
                </div>

                <CanEdit>
                  <TemplateButton
                    className="manager-home__send-btn manager-team__add-btn"
                    onClick={() => openModal("AddTeam")}
                    text="Add Teammate"
                    type="button"
                  />
                </CanEdit>
              </div>
            </div>

            <p className="manager-team__panel-description">
              Keep program contacts current, review profile details, and update
              the team list without leaving this workspace.
            </p>

            <div className="manager-team__panel-body">
              <Teams
                program={program}
                organization={organization}
                refreshToken={refreshToken}
              />
            </div>
          </section>
        </div>
      </Container>

      <ModalWrapper
        name={modalName}
        isOpen={isOpen}
        toggle={closeModal}
        onSaved={handleTeamSaved}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(Team);
